import React from 'react';
import { Helmet } from 'react-helmet';
const Metatags = (props) => {
    var _a, _b, _c;
    return (React.createElement(Helmet, null,
        props.pageMetaTags &&
            ((_a = Object.keys(props === null || props === void 0 ? void 0 : props.pageMetaTags)) === null || _a === void 0 ? void 0 : _a.map((key) => {
                if (key == 'title') {
                    return React.createElement("title", { key: key }, props === null || props === void 0 ? void 0 : props.pageMetaTags[key]);
                }
                if (key.startsWith('og:')) {
                    return React.createElement("meta", { key: key, property: key, content: props === null || props === void 0 ? void 0 : props.pageMetaTags[key] });
                }
                return React.createElement("meta", { key: key, name: key, content: props === null || props === void 0 ? void 0 : props.pageMetaTags[key] });
            })), (_c = (_b = props.meta) === null || _b === void 0 ? void 0 : _b.hreflangs) === null || _c === void 0 ? void 0 :
        _c.map((key) => {
            return React.createElement("link", { key: key, rel: "alternate", hrefLang: key.substring(0, key.indexOf(' ')), href: key.substring(key.indexOf(' ') + 1) });
        }),
        props.additionalMeta || []));
};
export default Metatags;
